/**
 * Resource nghiệp vụ chuyển kho
 * ndquang1 20.5.2024
 */
export default {
  Title: 'Chuyển kho',
  AccountingObject: 'Người thực hiện',
  Name: 'Họ và tên',
  StoreKeeperIn: 'Thủ kho nhập',
  StoreKeeperOut: 'Thủ kho xuất',
  DetailListNo: 'Số bảng kê',
};
